import { http } from '@/shared/api'
import { API } from '@/apps/adok/shared/api'

export interface ChangePasswordPayload {
  password: string
  passwordConfirmation: string
  currentPassword: string
}

/**
 * Hand-written rather than `createEntityApi`: nothing is read or listed here — the password
 * is only ever written, and neither path carries an id.
 */
export const changePassword = (payload: ChangePasswordPayload) =>
  http.patch<void>(API.password, payload)

export interface SendRecoveryLetterPayload {
  email: string
  captcha: string
}

export const sendRecoveryLetter = (payload: SendRecoveryLetterPayload) =>
  http.post<void>(API.passwordRecovery, payload)

export interface ResetPasswordPayload {
  password: string
  passwordConfirmation: string
  token: string
  captcha: string
}

export const resetPassword = (payload: ResetPasswordPayload) =>
  http.patch<void>(API.passwordRecovery, payload)
